<template>
    <aside
        v-window-resize="handleResizeWindow"
        class="menu mobile-menu"
    >
        <b-sidebar
            id="mobile-menu"
            ref="mobileSidebar"
            title="Menu"
            shadow="lg"
            backdrop
            data-cy="mobileMenuSidebar"
            @change="$emit('sidebar-change')"
        >
            <div
                ref="mobileSidebarWrapper"
                v-menu-scroll="handleScroll"
                class="mobile-menu-wrapper"
            >
                <div
                    :class="['menu-header-shadow', {'faded-out' : !showMobileMenuHeaderShadow}]"
                />
                <div
                    :class="['overflow-gradient', {'faded-out' : !showOverflowGradient}]"
                    data-cy="mobileMenuOverflowGradient"
                />
                <!-- Content to be displayed in the main section -->
                <slot />
            </div>
        </b-sidebar>
    </aside>
</template>

<script>
    import {MenuScroll} from '../../directives/menu-scroll';
    import {WindowResize} from '../../directives/window-resize';

    /**
     * @group Layout
     * A component to display a Mobile menu.
     * This component can be used in conjunction with `Menu.vue` to create a responsive navigation.
     * Mobile menu is hidden by default; generally toggled via hamburger button from the `Header.vue` component.
     */
    export default {
        name: 'MobileMenu',
        directives: {
            'menu-scroll': MenuScroll,
            'window-resize': WindowResize,
        },
        data() {
            return {
                showMobileMenuHeaderShadow: false,
                showOverflowGradient: true,
            };
        },
        methods: {
            handleResizeWindow() {
                let windowWidth = window.innerWidth;

                if (windowWidth > 1199) {
                    if (this.$refs.mobileSidebar) {
                        this.$refs.mobileSidebar.hide();
                    }
                }
            },
            handleScroll() {
                this.showMobileMenuHeaderShadow = (this.$refs.mobileSidebarWrapper.scrollTop !== 0);
                this.showOverflowGradient = (this.$refs.mobileSidebarWrapper.offsetHeight + this.$refs.mobileSidebarWrapper.scrollTop) < this.$refs.mobileSidebarWrapper.scrollHeight;
            },
        },
    };
</script>
